import React from "react";
import { Table } from "../UI/Table";
import { StyledReportModal } from "./styles";
import { createPortal } from "react-dom";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { getComparator } from "../../utils/helpers";
import { Link } from "react-router-dom";
import DownloadForOfflineIcon from "@mui/icons-material/DownloadForOffline";
import { SITE_LINKS_SCHEMA } from "../../router/navlinks";
const TITLE_MAPPINGS = {
  EMPLOYEES: {
    title: "All Active Employees",
    subtitle: "Complete list of employees with timesheet status",
  },
  SUBMITTED: {
    title: "List of Submitted Employees",
    subtitle: "Employees who have completed their timesheet entries",
  },
  PENDING: {
    title: "List of Pending Employees",
    subtitle: "Employees who haven’t submitted their timesheets yet",
  },
};
export const DashboardReportModal = ({
  reportData,
  filter,
  onClose,
  selectedweek,
  onDownload,
}) => {
  const columnDefs = [
    {
      field: "ResourceID",
      headerName: "Resource ID",
      sortable: true,
      filter: true,
    },
    {
      field: "ResourceName",
      headerName: "Resource Name",
      cellRenderer: (params) => {
        return (
          <Link
            to={SITE_LINKS_SCHEMA.UPDATE_RESOURCE.replace(
              ":resourceId",
              params.data.ResourceID
            )}
          >
            {params.value}
          </Link>
        );
      },
      sortable: true,
      filter: true,
    },
    { field: "Email", headerName: "Email", sortable: true, filter: true },
    {
      field: "Status",
      headerName: "Status",
      sortable: true,
      filter: true,
      cellStyle: (params) => ({
        color: params.value === "Pending" ? "red" : "green",
        fontWeight: "bold",
      }),
    },
    {
      field: "TotalHours",
      headerName: "Total Hours",
      sortable: true,
      filter: true,
    },
  ];
  const rowHeight = 50;
  const buffer = 40;
  const tableHeight = reportData.length
    ? reportData.length * rowHeight + buffer
    : buffer * 2;
  const { title: modalTitle, subtitle: modalSubTitle } =
    TITLE_MAPPINGS[filter] || {};
  const { firstDay, lastDay } = selectedweek;
  return createPortal(
    <StyledReportModal className="styled-report-modal">
      <div className="report-modal-content">
        <header className="modal-header">
          <div className="primary-row">
            <h1>{modalTitle}</h1>
          </div>
          <div className="secondary-row">
            <p className="subtitle">
              {modalSubTitle} {`for the week`}
              <strong className="report-week-label">{`${getComparator(
                firstDay
              )} to ${getComparator(lastDay)}`}</strong>{" "}
            </p>
            {reportData.length > 0 && (
              <div className="download-action">
                <DownloadForOfflineIcon onClick={onDownload} />
              </div>
            )}
          </div>
        </header>
        <div
          className="tma_report_table"
          style={{ height: `${tableHeight}px` }}
        >
          <Table
            columns={columnDefs}
            showPagination={false}
            rowSelection={"single"}
            autoFit={false}
            rowData={reportData}
          />
        </div>
        {reportData.length > 0 && (
          <p className="total-records-indicator">
            Total Records:<strong>{reportData.length}</strong>
          </p>
        )}
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={(theme) => ({
            position: "absolute",
            right: 0,
            top: 0,
            color: "#001b66",
          })}
        >
          <CloseIcon />
        </IconButton>
      </div>
    </StyledReportModal>,
    document.body
  );
};
